module.exports = __webpack_public_path__ + "media/images/icons/price-694de58bcbc0ac1dc915278b34fc0c58.svg";